// utils.ts
export const formatName = (name?: string | null | undefined): string => {
  if (!name) return "";
  const firstLetter = name.charAt(0).toUpperCase();
  const restOfString = name.slice(1).toLowerCase();
  return firstLetter + restOfString;
};
